export const PLACEHOLDER = '-';

export const EDIT_MODE_OFF = '';

export const VIEW_MODES = {
  cost: 'Cost Details',
  adjustments: 'Adjustments',
};

export const propertyTypesWithImageAnalysis = ['singleFamilyResidence', 'townhouse'];
